import { IEvent } from '../../Types/Event';
import { IResource } from '../../Types/Resource';
import { IField } from '../../Types/Field';

const formatDate = (d: string): string => {
  const date = new Date(d);
  return date.toLocaleDateString() + ' @ \n' + date.toLocaleTimeString();
}

// const createChildren = (id: string, events: IEvent[], fields: IField[]): IResource[] => {
//   const field_events = events.filter(e => e.resourceId.includes(id));
//   return field_events.map(e => {
//     return {
//       id: e.id + e.eventType,
//       type: e.eventType,
//       title: e.title,
//       fieldName: e.title + ' @ ' + formatDate(e.prediction.modifiedTimstamp),
//       predictionTimstamp: formatDate(e.prediction.modifiedTimstamp), //new Date(e.prediction.modifiedTimstamp).toLocaleDateString() + ' @ \n' + new Date(e.prediction.modifiedTimstamp).toLocaleTimeString(),
//       dates: { start: e.start, end: e.end },
//     } as IResource;
//   });
// };

// create the resource list out of all the events
export const computeToResource = (events: IEvent[], fields: IField[]): IResource[] => {
  var allResources: IResource[] = events.map((e: IEvent) => {
    if (e === undefined) {
      return {
        id: "unknown",
        title: "unknown",
        fieldName: "unknown",
        citycounty: "unknown"
      } as IResource;
    }

    return {
      id: e.id + e.eventType,
      title: e.eventType,
      fieldName: e.title + ' @ ' + formatDate(e.prediction.modifiedTimstamp),
      predictionTimstamp: formatDate(e.prediction.modifiedTimstamp), //new Date(e.prediction.modifiedTimstamp).toLocaleDateString() + ' @ \n' + new Date(e.prediction.modifiedTimstamp).toLocaleTimeString(),
      dates: { start: e.start, end: e.end },
    } as IResource;

    // return {
    //   id: e.id,
    //   fieldName: e.title + ' @ ' + formatDate(e.prediction.modifiedTimstamp),
    //   title: e.title,
    //   // citycounty: e.prediction?.city,
    //   predictionTimstamp: formatDate(e.prediction.modifiedTimstamp), //new Date(e.prediction.modifiedTimstamp).toLocaleDateString() + ' @ \n' + new Date(e.prediction.modifiedTimstamp).toLocaleTimeString(),
    //   children: [
    //     ...createChildren(e.id, events, fields)
    //   ],
    //   dates: { }
    //   //dates: { start: e.start, end: e.end },
    // } as IResource;
  });

  const uniqueResources = allResources.filter((object, index) => index === allResources.findIndex(obj => JSON.stringify(obj) === JSON.stringify(object)));

  let r: IResource[] = [...uniqueResources];
  if (events.length < 1) {
    return r;
  }

  return r;
}


// Messsy!!! need to decide what level of hirearchy is useful/necessary
// const computeNestedResource = (events: IEvent[]): IResource[] => {
//   console.log("computeNestedResource - events: ", events)

//   var allResources: IResource[] = events.map((e: IEvent) => {
//     return { id: e.resourceId, title: e.resourceName, } as IResource;
//   });
//   const uniqueResources = allResources.filter((object,index) => index === allResources.findIndex(obj => JSON.stringify(obj) === JSON.stringify(object)));

//   var allCountries: IResource[] = events.map((e: IEvent) => {
//     return { id: e.prediction?.country_code.toLowerCase(), title: e.prediction?.country, } as IResource;
//   });
//   var uniqueCountries = allCountries.filter((object,index) => index === allCountries.findIndex(obj => JSON.stringify(obj) === JSON.stringify(object)));
//   console.log("uniqueCountries: ", uniqueCountries);


//   var uniqueCities: IResource[] = [];
//   uniqueCountries.map(country => {
//     var allCities = events.filter(e => e.prediction?.country_code.toLowerCase() == country.id.toLowerCase()).map(c => {
//       return { id: c.prediction?.postalcode.toLowerCase(), title: c.prediction?.city }
//     })
//     console.log("cities: ", allCities);
//     var uniqueCities = allCities.filter((object,index) => index === allCities.findIndex(obj => JSON.stringify(obj) === JSON.stringify(object)));
//     uniqueCities.map(c => {
//       var fields = events.filter(e => e.prediction?.country == country.id && e.prediction?.city == c.title).map(f => {
//         return { id: f.resourceId, title: f.resourceName }
//       });
//       c.children = fields
//     })

//     country.children = uniqueCities;
//   });

//   return uniqueCountries;
// }